// eslint-disable-next-line import/prefer-default-export
export const LOADER_SIZES = ["small", "medium", "large"];